import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppContextProvider"] */ "/vercel/path0/src/app/_utils/AppContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/Navbar/Navbar.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["handleNavbarToggle","default"] */ "/vercel/path0/src/app/(portfolio)/_layout/Navbar/NavbarToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/_layout/Navbar/ThemeSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(portfolio)/_layout/Navigation.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portfolio)/_layout/Particle.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
